import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  return {
    article: {
      padding: "10px 20px",
      borderTop: "1px solid #e6e6e6",
      wordBreak: "break-word",
      "&:nth-child(even)": {
        backgroundColor: "#fbfbfb"
      }
    },
    horseName: {
      fontWeight: 700,
      marginBottom: 5,
      wordBreak: "break-word"
    },
    trainerName: {
      marginBottom: 26,
      wordBreak: "break-word"
    },
    examNotesListItem: {
      padding: "10px 20px",
      borderTop: "1px solid #e6e6e6",
      wordBreak: "break-word",
      "&:nth-child(even)": {
        backgroundColor: "#fbfbfb"
      }
    },
    examNotesContainerBody: {
      fontSize: 12
    },
    createDateTime: {
      color: theme.palette.text.secondary,
      fontSize: 10
    },
    commentCreator: {
      fontSize: 10
    },
    flagged: {
      display: "flex",
      alignItems: "center"
    },
    flaggedTitle: {
      marginRight: 5
    }
  };
});
